import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material';
import { observable, runInAction, makeObservable } from 'mobx';
import { observer } from 'mobx-react';
import React from 'react';
import MinutaService from '../../services/MinutaService';
import ServidorService from '../../services/ServidorService';
import VisualizarMinuta from '../escaninho/assinatura/VisualizarMinuta';

interface IPropsResponsaveisMinutas {
    idProcesso: number;
    processo: any;
}


class ResponsaveisMinutas extends React.Component<IPropsResponsaveisMinutas> {

    minutas = [];

    constructor(props: IPropsResponsaveisMinutas) {
        super(props);

        makeObservable(this, {
            minutas: observable
        });
    }

    // componentDidMount/componentDidUpdate precisam ser síncronos (não podem
    // retornar Promise): em React 19 + mobx-react 9, uma versão `async` quebra
    // permanentemente a reatividade do observer() para esta instância.
    componentDidMount() {
        (async () => {
            await this.carregarMinutas();
        })();
    }

    componentDidUpdate(prevProps: IPropsResponsaveisMinutas) {
        (async () => {
            if (prevProps.idProcesso !== this.props.idProcesso && this.props.idProcesso) {
                await this.carregarMinutas();
            }
        })();
    }

    carregarMinutas = async () => {

        const despacho = await MinutaService.recuperarMinuta(this.props.idProcesso, 1, false);
        const decisao = await MinutaService.recuperarMinuta(this.props.idProcesso, 2, false);
        const acordao = await MinutaService.recuperarMinuta(this.props.idProcesso, 3, false);
        const minutas = [];

        if (despacho && despacho.numero && despacho.tipo?.codigo) {
            if (despacho.cpfResponsavel) {
                const usuarioResponsavel = await ServidorService.buscarInformacoesUsuario(despacho.cpfResponsavel);
                if (usuarioResponsavel) {
                    despacho.nomeResponsavel = (usuarioResponsavel as any).nome;
                }
            }
            minutas.push(despacho);
        }
        if (decisao && decisao.numero && decisao.tipo?.codigo) {
            if (decisao.cpfResponsavel) {
                const usuarioResponsavel = await ServidorService.buscarInformacoesUsuario(decisao.cpfResponsavel);
                if (usuarioResponsavel) {
                    decisao.nomeResponsavel = (usuarioResponsavel as any).nome;
                }
            }
            minutas.push(decisao);
        }
        if (acordao && acordao.numero && acordao.tipo?.codigo) {
            if (acordao.cpfResponsavel) {
                const usuarioResponsavel = await ServidorService.buscarInformacoesUsuario(acordao.cpfResponsavel);
                if (usuarioResponsavel) {
                    acordao.nomeResponsavel = (usuarioResponsavel as any).nome;
                }
            }
            minutas.push(acordao);
        }
        runInAction(() => {
            this.minutas = minutas;
        });
    }

    render() {
        return (
            <div>
                {this.minutas && (this.minutas.length > 0) &&
                    <Accordion expanded={true}>
                        <AccordionSummary style={{ marginBottom: '-20px', cursor: 'inherit' }}>
                            <b className="titulo">Responsáveis pelas minutas:</b>
                        </AccordionSummary>
                        <AccordionDetails>
                            <div className='divFlexColumn'>

                                {this.minutas.map(minuta => (
                                    <div key={minuta.numero}>
                                        <b className="titulo">{minuta?.tipo?.descricao}:</b> {minuta.nomeResponsavel ? minuta.nomeResponsavel : 'Sem responsável'}
                                        {minuta?.tipo?.codigo && <VisualizarMinuta processo={this.props.processo} minuta={minuta} />}
                                    </div>)
                                )}
                            </div>
                        </AccordionDetails>
                    </Accordion>
                }
            </div>
        );
    }
}

export default observer(ResponsaveisMinutas);
